import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import NoAccessMessage from './NoAccessMessage';

const SuperAdminProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isLoading } = useAuth0();
  if (isLoading) return null;
  const roles = (user && Array.isArray(user["https://bespot.com/roles"]) ? user["https://bespot.com/roles"] : []) as string[];
  const isSuperAdmin = roles.includes('superadmin') || roles.includes('support');
  if (!isSuperAdmin) return <NoAccessMessage />;
  return <>{children}</>;
};

export default SuperAdminProtectedRoute;
